import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: '首页' }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/normal/about/About.vue'),
      meta: { title: '关于我们' }
    },
    {
      path: '/zbAbout',
      name: 'zbAbout',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "zbAbout" */ './views/normal/zhenBeiAbout/About.vue'),
      meta: { title: '关于我们' }
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('./views/demo/Demo.vue'),
      meta: { title: '小镜' }
    },
    {
      path: '/changeDev',
      name: 'changeDev',
      component: () => import('./views/main/changeDev/ChangeDev.vue'),
      meta: { title: '切换设备' }
    },
    {
      path: '/phoneBinding',
      name: 'phoneBinding',
      component: () => import('./views/main/phoneBinding/index/index.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/carPlate',
      name: 'carPlate',
      component: () => import('./views/main/phoneBinding/carPlate/index.vue'),
      meta: { title: '完善车辆信息' }
    },
    {
      path: '/carText',
      name: 'carText',
      component: () => import('./views/main/phoneBinding/carText/index.vue'),
      meta: { title: '车辆品牌选择' }
    },
    {
      path: '/carBrand',
      name: 'carBrand',
      component: () => import('./views/main/phoneBinding/brand/index.vue'),
      meta: { title: '车辆品牌选择' }
    },
    {
      path: '/carModel',
      name: 'carModel',
      component: () => import('./views/main/phoneBinding/carModel/index.vue'),
      meta: { title: '车辆车型选择' }
    },
    {
      path: '/recordData',
      name: 'recordData',
      component: () => import('./views/main/phoneBinding/recordData/index.vue'),
      meta: { title: '数据录入' }
    },
    {
      path: '/notification',
      name: 'notification',
      component: () => import('./views/main/notification/index.vue'),
      meta: { title: '通知设置' }
    },
    {
      path: '/takePicture',
      name: 'takePicture',
      component: () => import('./views/main/takePicture/TakePicture.vue'),
      meta: { title: '实时拍照' }
    },
    {
      path: '/takeVideo',
      name: 'takeVideo',
      component: () => import('./views/main/takeVideo/TakeVideo.vue'),
      meta: { title: '实时视频' }
    },
    {
      path: '/queryMedia',
      name: 'queryMedia',
      component: () => import('./views/main/queryMedia/QueryMedia.vue'),
      meta: { title: '历史查询' }
    },
    {
      path: '/devCenter',
      name: 'devCenter',
      component: () => import('./views/main/devCenter/DevCenter.vue'),
      meta: { title: '设备中心' }
    },
    {
      path: '/positionServer',
      name: 'positionServer',
      component: () => import('./views/main/positionServer/PositionServer.vue'),
      meta: { title: '实时位置' }
    },
    {
      path: '/photoAlbum',
      name: 'photoAlbum',
      component: () => import('./views/main/photoAlbum/PhotoAlbum.vue'),
      meta: { title: '网络相册' }
    },
    {
      path: '/photoList',
      name: 'photoList',
      component: () => import('./views/main/photoList/PhotoList.vue'),
      meta: { title: '网络相册' }
    },
    {
      path: '/showMedia',
      name: 'showMedia',
      component: () => import('./views/main/showMedia/ShowMedia.vue'),
      meta: { title: '媒体详情' }
    },
    {
      path: '/tripList',
      name: 'tripList',
      component: () => import('./views/main/tripList/TripList.vue'),
      meta: { title: '行程报告' }
    },
    {
      path: '/parkingList',
      name: 'parkingList',
      component: () => import('./views/main/parkingList/ParkingList.vue'),
      meta: { title: '停车报告' }
    },
    {
      path: '/parkingPosition',
      name: 'parkingPosition',
      component: () => import('./views/main/parkingPosition/ParkingPosition.vue'),
      meta: { title: '停车位置' }
    },
    {
      path: '/reserveNavigation',
      name: 'reserveNavigation',
      component: () => import('./views/main/reserveNavigation/ReserveNavigation.vue'),
      meta: { title: '预约导航' }
    },
    {
      path: '/simCard',
      name: 'simCard',
      component: () => import('./views/main/simCard/SimCard.vue'),
      meta: { title: '我的SIM卡' }
    },
    {
      path: '/simWifi',
      name: 'simWifi',
      component: () => import('./views/main/simWifi/SimWifi.vue'),
      meta: { title: '我的SIM卡' }
    },
    {
      path: '/realName',
      name: 'realName',
      component: () => import('./views/normal/realName/RealName.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/realNameAgree',
      name: 'realNameAgree',
      component: () => import('./views/normal/realNameAgree/RealNameAgree.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/noImei',
      name: 'noImei',
      component: () => import('./views/main/noImei/NoImei.vue'),
      meta: { title: '请绑定设备' }
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('./views/main/error/Error.vue'),
      meta: { title: '异常提示' }
    },
    {
      path: '/sendAudio',
      name: 'sendAudio',
      component: () => import('./views/normal/sendAudio/SendAudio.vue'),
      meta: { title: '千里传音' }
    },
    {
      path: '/unbound',
      name: 'unbound',
      component: () => import('./views/normal/unbound/Unbound.vue'),
      meta: { title: '设备解绑' }
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('./views/normal/share/Share.vue'),
      meta: { title: '发送给朋友' }
    },
    {
      path: '/pickupServer',
      name: 'pickupServer',
      component: () => import('./views/normal/pickupServer/PickupServer.vue'),
      meta: { title: '接人服务' }
    },
    {
      path: '/guidingWay',
      name: 'guidingWay',
      component: () => import('./views/normal/guidingWay/guidingWay.vue'),
      meta: { title: '好友指路' }
    },
    {
      path: '/trackQuery',
      name: 'trackQuery',
      component: () => import('./views/normal/trackQuery/TrackQuery.vue'),
      meta: { title: '轨迹服务' }
    },
    {
      path: '/airclean',
      name: 'airClean',
      component: () => import(/* webpackChunkName: "about" */ './views/main/airClean/airClean.vue'),
      meta: { title: '空气净化器' }
    },
    {
      path: '/warrantyCard',
      name: 'warrantyCard',
      component: () => import(/* webpackChunkName: "warrantyCard" */ './views/main/warrantyCard/index.vue'),
      meta: { title: '电子质保卡' }
    },
        {
      path: '/zhenBeiWarrantyCard',
      name: 'zhenBeiWarrantyCard',
      component: () => import(/* webpackChunkName: "zhenBeiWarrantyCard" */ './views/main/zhenBeiWarrantyCard/index.vue'),
      meta: { title: '电子质保卡' }
    },
    {
      path: '/tuyunDownload',
      name: 'tuyunDownload',
      component: () => import('./views/normal/tuyunDownload/TuyunDownload.vue'),
      meta: { title: '途云下载' }
    },
  ]
})
